/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */
/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
import React from 'react';

// Alias
import Checkbox from '../../checkbox';

const OldCheckbox = (props) => <Checkbox oldEventParameterOrder {...props} />;

export default OldCheckbox;
